import { Currency, CurrencySettings, CurrencyUtil, ModelRow } from "@mcleod/core";
import { AutogenLayoutCollectionsExpand } from "./autogen/AutogenLayoutCollectionsExpand";
import { TableRowDisplayEvent } from "@mcleod/components";
import { CollectionsUtil } from "./CollectionsUtil";

export class CollectionsExpand extends AutogenLayoutCollectionsExpand {
    public invoiceCurrencyType: string | null = CurrencySettings.getTransactionalCurrency();

    sourceOpenItemCollectionsAfterExecution() {
        this.updateTotals(this.tableInvoiceActivity.data);
    }

    tableInvoiceActivityOnRowDisplay(event: TableRowDisplayEvent) {
        const tableRow = event.getTableRow();
        const modelRow = tableRow.data as ModelRow;

        tableRow.forEveryChildComponent((component) => {
            CollectionsUtil.setTooltipContent(component, modelRow);
        });
    }

    private updateTotals(data: ModelRow[]) {
        const [totalAmountBilled, totalAmountPaid, totalAdjustments, totalOutstandingBalance] =
            this.calculateTotals(data, [
                "amount_billed",
                "amount_paid",
                "adjustments",
                "outstanding_balance"
            ]);

        this.textboxTotalAmountBilled.text = CurrencyUtil.formatCurrency(totalAmountBilled);
        this.textboxTotalAmountPaid.text = CurrencyUtil.formatCurrency(totalAmountPaid);
        this.textboxTotalPaymentAdjustments.text = CurrencyUtil.formatCurrency(totalAdjustments);
        this.textboxTotalOutstandingBalance.text = CurrencyUtil.formatCurrency(totalOutstandingBalance);
    }

    private calculateTotals(sourceData: ModelRow[], fields: string[]): Currency[] {
        return fields.map(field => {
            const total = new Currency({ amount: 0, currency_code: this.invoiceCurrencyType, conversion_date: new Date() });
            sourceData.forEach(row => {
                const amount = row.getCurrency(field, null);
                if (amount) {
                    total.add(amount);
                }
            });
            return total;
        });
    }
}
